/**
 * @description 「是」或「否」代碼 (enum)
 */
export enum YesNoCodesEnum {
  /** 否 */
  No = 'N',
  /** 是 */
  Yes = 'Y'
}
